import { Box, Divider, Typography } from "@mui/material"
import { PetDetailCardStyled } from "./pet-detail-card.styles"
import { PetDetailCardProps } from "./types"
import SelectFormField from "../../../../components/form-fields/select-field/select-form-field"
import { useForm } from "react-hook-form"
import { SelectedPets } from "../pet-details/types"
import { useContext, useEffect } from "react"
import { StepperDataContext } from "../../context/stepper-context"
import TextInputFormField from "../../../../components/form-fields/text-input-field/text-input-form-field"

const PetDetailCard: React.FC<PetDetailCardProps> = ({
    data,
    appointmentTypes,
}) => {
    const { selectedPatients, setSelectedPatients } = useContext(StepperDataContext)

    const { control, watch, setValue } = useForm({
        mode: "all",
    })
    useEffect(() => {
        if(selectedPatients.length) {
            const patient = selectedPatients.find(pet => pet.integration_id === data.integration_id)
            if(patient) {
                setValue('appointment_type', patient.appointment_type)
                setValue('reason', patient.reason)
            }
        }
    }, [selectedPatients])

    useEffect(() => {
        const { appointment_type, reason } = watch()
        setSelectedPatients((selectedPatients: SelectedPets) => {
            let selectedPatient = selectedPatients.find(pet => pet.integration_id === data.integration_id)
            if (selectedPatient) {
                selectedPatient.appointment_type = appointment_type
                selectedPatient.reason = reason

                const otherSelectedPatients = selectedPatients.filter(pet => pet.integration_id !== data.integration_id)
                return [...otherSelectedPatients, selectedPatient]
            }
            return selectedPatients
        })
    }, [watch().appointment_type, watch().reason])

    const handleCollapse = () => {
        setSelectedPatients((selectedPatients: SelectedPets) => {
            const isSelected = selectedPatients.some(pet => pet.integration_id === data.integration_id)
            if (!isSelected) {
                return [...selectedPatients, data]
            } else {
                return selectedPatients.filter(pet => pet.integration_id !== data.integration_id)
            }
        })
    }

    const openCollapse = selectedPatients.some(pet => pet.integration_id === data.integration_id)

    return (
        <PetDetailCardStyled className={`${openCollapse ? 'opened' : ''}`}>
            <Box className="top-part" onClick={handleCollapse}>
                <Box className="name-and-type-gender">
                    <Typography className="name">{data.name}</Typography>
                    {(data.type || data.gender) && <Typography className="type-gender">{`${data.type} - ${data.gender}`}</Typography>}
                </Box>
                <Box>
                    <Typography className="age">{data.age}</Typography>
                </Box>
            </Box>
            {openCollapse && <>
                <Divider />
                <SelectFormField
                    name="appointment_type"
                    control={control}
                    placeholder="Select here"
                    label="Appointment type"
                    options={appointmentTypes}
                />
                <TextInputFormField
                    name="reason"
                    control={control}
                    label="Reason"
                    placeholder="Enter here"
                />
            </>}
        </PetDetailCardStyled>
    )
}

export default PetDetailCard